import { css } from '@mui/styled-engine'

import type { HAVDesignTokensInterface } from '../interfaces'

const havH1Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.xxx.big};
  font-family: ${HAVDesignTokens.typography.font.weight.bold};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havH2Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-family: ${HAVDesignTokens.typography.font.primary};
  font-size: ${HAVDesignTokens.typography.font.size.xx.big};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havH3Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.x.big};
  font-family: ${HAVDesignTokens.typography.font.weight.bold};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havH4Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.big};
  font-family: ${HAVDesignTokens.typography.font.weight.medium};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havH5Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.x.medium};
  font-family: ${HAVDesignTokens.typography.font.weight.bold};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havSubtitleText = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.xxx.medium};
  font-family: ${HAVDesignTokens.typography.font.weight.medium};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havDefault01Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-family: ${HAVDesignTokens.typography.font.primary};
  font-size: ${HAVDesignTokens.typography.font.size.small};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

const havDefault02Text = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  font-size: ${HAVDesignTokens.typography.font.size.x.small};
  font-family: ${HAVDesignTokens.typography.font.weight.bold};
  line-height: ${HAVDesignTokens.typography.lineHeight};
`

export {
  havDefault01Text,
  havDefault02Text,
  havH1Text,
  havH2Text,
  havH3Text,
  havH4Text,
  havH5Text,
  havSubtitleText,
}
